export default __webpack_public_path__ + "static/media/Isologo.eb458893.png";